import { useState, forwardRef } from 'react';
import { Loader2 } from 'lucide-react';

const ImageWithLoader = forwardRef(({ src, alt, className, ...props }, ref) => {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);

  const handleLoad = () => {
    setLoaded(true);
  };

  const handleError = () => {
    setLoaded(true);
    setError(true);
  };

  return (
    <div className={`relative overflow-hidden ${className || ''}`}>
      {!loaded && (
        <div className="absolute inset-0 flex items-center justify-center bg-gray-100 z-10 transition-opacity duration-300">
          <Loader2 className="w-8 h-8 text-gray-400 animate-spin" />
        </div>
      )}

      {error ? (
        <div className="flex items-center justify-center w-full h-full min-h-[200px] bg-gray-100 text-gray-400">
          <span className="text-sm">Failed to load image</span>
        </div>
      ) : (
        <img
          ref={ref}
          src={src}
          alt={alt}
          className={`${className || ''} ${loaded ? 'opacity-100' : 'opacity-0'} transition-opacity duration-300`}
          onLoad={handleLoad}
          onError={handleError}
          {...props}
        />
      )}
    </div>
  );
});

ImageWithLoader.displayName = 'ImageWithLoader';

export default ImageWithLoader;
